module.exports = __webpack_public_path__ + "img/image008.83628817.png";